import { useEffect, useState } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import HtmlEnrollmentDocument from "./HtmlEnrollmentDocument";

export default function DocumentThumbnailV2({ documentType }) {
  const [preview, setPreview] = useState("");

  useEffect(() => {
    const styles = [...document.querySelectorAll('style, link[rel="stylesheet"]')]
      .map((node) => node.outerHTML)
      .join("\n");
    const markup = renderToStaticMarkup(<HtmlEnrollmentDocument documentType={documentType} />);
    setPreview(
      `<!doctype html><html lang="es"><head><meta charset="utf-8"><base href="${window.location.origin}/">${styles}<style>html,body{margin:0!important;padding:0!important;overflow:hidden;background:#fff}.react-document{gap:0}.react-document__page{box-shadow:none}.react-document__page:not(:first-child){display:none}</style></head><body>${markup}</body></html>`
    );
  }, [documentType]);

  return (
    <div className="formularios-v2__miniature" aria-hidden="true">
      <iframe
        title={`Miniatura de ${
          documentType === "solicitud" ? "la solicitud de inscripción" : "el anexo de inscripción"
        }`}
        srcDoc={preview}
        tabIndex={-1}
      />
    </div>
  );
}
